export default __webpack_public_path__ + "static/media/celebration-animate.7e38c8fd.svg";